import angular from 'angular';
import avatarModule from '../avatarModule';

function recentItemsController($scope, avatarService, avatarConstantService) {
  'ngInject';

  $scope.loading = false;
  $scope.items = [];
  $scope.emptyMessage = avatarConstantService.recent.emptyMessage;

  let listType = 'All';
  let loaded = false;

  function isActiveTab() {
    return $scope.selectedTab.name === 'Recent';
  }

  function loadRecentItems() {
    if (!isActiveTab() || loaded || $scope.loading) {
      return;
    }

    $scope.loading = true;
    $scope.items = [];

    avatarService.getRecentItems(listType).then(
      function(result) {
        $scope.items = [];

        for (let i = 0; i < result.data.length; i++) {
          const item = result.data[i];
          $scope.addItemThumbnailAndLink(item);
          $scope.updateItemSelected(item);
        }
        $scope.items = result.data;
        $scope.loading = false;
        loaded = true;
      },
      function() {
        $scope.systemFeedback.error(avatarConstantService.recent.couldNotLoadList);
      }
    );
  }

  $scope.$on(avatarConstantService.events.wornAssetsChanged, function(event, assetIds) {
    angular.forEach($scope.items, function(item) {
      $scope.$parent.updateItemSelected(item);
    });
  });

  $scope.$on(avatarConstantService.events.outfitDeleted, function(event, itemDeleted) {
    angular.forEach($scope.items, function(item, index) {
      if (item.id === itemDeleted.id) {
        $scope.items.splice(index, 1);
      }
    });
  });

  $scope.$on(avatarConstantService.events.menuClicked, function(event, obj) {
    const { tab } = obj;
    const { menu } = obj;
    if (tab.name === 'Recent') {
      listType = menu.name;
      loaded = false;
      loadRecentItems();
    }
  });
  $scope.$on(avatarConstantService.events.pageLoaded, function(event, result) {
    loadRecentItems();
  });
}

avatarModule.controller('recentItemsController', recentItemsController);

export default recentItemsController;
